export const REPORT_PHYSICAL_STATES = ['solid', 'liquid', 'gas'] as const;
export type ReportPhysicalState = (typeof REPORT_PHYSICAL_STATES)[number];

/** An explicit empty selection must not fall back to a catalog default. */
export function reportPhysicalStates(entry: {
  physicalStates?: readonly string[] | null;
  physicalState?: string | null;
}): ReportPhysicalState[] {
  const values = entry.physicalStates ?? (entry.physicalState ? [entry.physicalState] : []);
  return REPORT_PHYSICAL_STATES.filter((state) => values.includes(state));
}
